module.exports = __webpack_public_path__ + "img/feature_buy_bonus_en.bac14c1b.png";